<template>
  <div class="base-item">
    <div class="content relative">
      <component :is="container" :href="link" :target="target" @click="emits('go', data)">
        <XTag
          v-if="data?.is_new"
          type="new"
          size="large"
          class="absolute left-[8px] top-[8px] z-10"
        />

        <div class="h-[162px] w-[288px] overflow-hidden cover rounded-[12px] relative">
          <slot name="img">
            <Resource
              :src="data?.cover_image_url || DEFAULT_IMG"
              class="h-full w-full pic"
              :transform-resource="transformImage"
            />
          </slot>
          <div class="arrow">
            <iconpark-icon name="arrow-r"></iconpark-icon>
          </div>
        </div>
        <div class="p-[12px_16px] desc w-[288px]">
          <div class="text-14 leading-[24px] line-clamp-2 text-font-1 title h-[48px] mb-[12px]">
            <template v-if="$slots.title">
              <slot name="title"></slot>
            </template>
            <span v-else>
              {{ data?.title }}
            </span>
          </div>
          <slot name="other"></slot>
        </div>
      </component>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { RouteLocationAsRelativeGeneric } from 'vue-router';
import { NuxtLink } from '#components';
import { transformImage } from '~/utils';

export interface IBaseCardData {
  title: string;
  cover_image_url: string;
  is_new: boolean;
}

const props = defineProps<{
  data: IBaseCardData;
  link?: RouteLocationAsRelativeGeneric;
  target?: string;
}>();

const container = props.link ? NuxtLink : 'div';

const DEFAULT_IMG = getFeUrl('/youyan-platform/png/home/img-placeholder-2x.png');

const emits = defineEmits(['go']);
</script>

<style lang="scss" scoped>
.base-item {
  @apply cursor-pointer;
  .content {
    @apply relative h-full w-full overflow-hidden;
    .pic {
      transition: all 0.5s ease-out;
    }
    .arrow {
      @apply h-[36px] w-[36px] rounded-full absolute right-[10px] bottom-[10px] flex-y-center justify-center opacity-0;
      transition: all 0.12s ease-out;
      transform: translateX(100%);
      background-color: #fff;
      color: var(--black-1);
    }
  }
  &:hover {
    .pic {
      transform: scale(1.1);
    }
    .arrow {
      @apply opacity-100;
      transform: translateX(0);
    }
  }
}
</style>
